import { Component, effect, input, model, output, signal } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import {
  ISetUserPackageStatusCommand,
  SetUserPackageStatusCommand,
} from '../../../../infrastructure/shared/model/fss.api';
import { CheckCircle } from '../../../../infrastructure/shared/icons/check-circle/check-circle';
import { CurrencyNumberPipe } from '../../../../infrastructure/shared/pipes/currency-number.pipe';
import { ToggleButton } from '../../../../infrastructure/shared/ui/toggle-button/toggle-button';
import {
  ButtonComponent,
  ButtonSeverity,
  ButtonSize,
} from '../../../../infrastructure/shared/ui/button/button';
import { FormControl, Validators } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControlPipe } from '../../../../infrastructure/shared/pipes/form-control.pipe';
import { Lock03 } from '../../../../infrastructure/shared/icons/lock-03/lock-03';
import { TextInput } from '../../../../infrastructure/shared/ui/text-input/text-input';
import { XClose } from '../../../../infrastructure/shared/icons/x-close/x-close';
import { CurrencyEuroCircle } from '../../../../infrastructure/shared/icons/currency-euro-circle/currency-euro-circle';

@Component({
  standalone: true,
  selector: 'app-invoice-sent-dialog',
  imports: [
    Dialog,
    CheckCircle,
    CurrencyNumberPipe,
    ToggleButton,
    ButtonComponent,
    FormControlPipe,
    TextInput,
    XClose,
    CurrencyEuroCircle,
  ],
  templateUrl: './invoice-sent-dialog.html',
  styleUrl: './invoice-sent-dialog.scss',
})
export class InvoiceSentDialog {
  isVisible = model.required<boolean>();
  command = input.required<SetUserPackageStatusCommand>();
  submitted = output<SetUserPackageStatusCommand>();

  showDiscount = signal(false);
  discountPrice = new FormControl<number | null>(null);

  protected readonly ButtonSeverity = ButtonSeverity;
  protected readonly ButtonSize = ButtonSize;

  constructor() {
    this.discountPrice.valueChanges.pipe(takeUntilDestroyed()).subscribe((value) => {
      const original = this.command().packagePrice.originalPrice!;
      const final = value ? original - value : original;
      this.command().packagePrice.price = final > 0 ? final : 0;
    });

    effect(() => {
      if (this.showDiscount()) {
        this.discountPrice.setValidators([
          Validators.required,
          Validators.min(1),
          Validators.max(this.command().packagePrice.originalPrice!),
        ]);
      } else {
        this.discountPrice.clearValidators();
        this.discountPrice.reset();
      }
      this.discountPrice.updateValueAndValidity();
    });
  }

  onSubmit(): void {
    if (this.showDiscount() && this.discountPrice.invalid) {
      this.discountPrice.markAsTouched();
      return;
    }

    this.submitted.emit(this.command());
  }

  onCancel(): void {
    this.isVisible.set(false);
  }
}
